type PhoneNumber = {
  phonePrefix?: string;
  phoneNumber: string;
};

export function getPhoneNumberWithSpacing(phoneNumber: string) {
  const phoneNumberWithSpacing = `${phoneNumber.substring(
    0,
    3,
  )} ${phoneNumber.substring(
    3,
    phoneNumber.length - 4,
  )} ${phoneNumber.substring(phoneNumber.length - 4)}`;
  return phoneNumberWithSpacing;
}

export function getHiddenPhoneNumber({
  phonePrefix,
  phoneNumber,
}: PhoneNumber) {
  const getHiddenPhoneNumberPart = () => {
    if (phoneNumber.length <= 5) {
      return phoneNumber;
    }
    const initialClearPart = phoneNumber.slice(0, 3);
    const hiddenPart = phoneNumber
      .slice(3, phoneNumber.length - 2)
      .replace(/./g, '*');
    const finalClearPart = phoneNumber.slice(-2);
    const hiddenPhoneNumberPart = `${initialClearPart}${hiddenPart}${finalClearPart}`;
    return hiddenPhoneNumberPart;
  };

  return phonePrefix != null
    ? `${phonePrefix} ${getHiddenPhoneNumberPart()}`
    : getHiddenPhoneNumberPart();
}
